angular.module('manufacturing')
    .controller("ManufacturingOrderRealisationHistoryController", function ($uibModalInstance, ManufacturingOrderRealisation, data) {
        this.$onInit = () => {
            ManufacturingOrderRealisation.query({orderId: data.id}).$promise
                .then(items => this.items = items);
        };

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
    })
